// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/ChickenFightWeightClassPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/**
 * 닭싸움 체급 (국제닭싸움연맹 공식 경기 부문표)
 *
 * 전 부문 체중 제한이 없어 체급은 ABSOLUTE 하나뿐이다.
 * 부문은 AgeDivisionPayload(초등부 저학년 · 초등부 고학년 · 중등부 · 고등부 · 성인부) 와
 * GenderPayload(남자부 · 여자부) 의 조합으로 표현한다.
 */
export enum ChickenFightWeightClassPayload {
  CHICKEN_FIGHT_WEIGHT_CLASS_UNKNOWN = 0,
  /** CHICKEN_FIGHT_ABSOLUTE - ABSOLUTE 무체급 (체중 제한 없음) */
  CHICKEN_FIGHT_ABSOLUTE = 1,
  UNRECOGNIZED = -1,
}

export function chickenFightWeightClassPayloadFromJSON(object: any): ChickenFightWeightClassPayload {
  switch (object) {
    case 0:
    case "CHICKEN_FIGHT_WEIGHT_CLASS_UNKNOWN":
      return ChickenFightWeightClassPayload.CHICKEN_FIGHT_WEIGHT_CLASS_UNKNOWN;
    case 1:
    case "CHICKEN_FIGHT_ABSOLUTE":
      return ChickenFightWeightClassPayload.CHICKEN_FIGHT_ABSOLUTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChickenFightWeightClassPayload.UNRECOGNIZED;
  }
}

export function chickenFightWeightClassPayloadToJSON(object: ChickenFightWeightClassPayload): string {
  switch (object) {
    case ChickenFightWeightClassPayload.CHICKEN_FIGHT_WEIGHT_CLASS_UNKNOWN:
      return "CHICKEN_FIGHT_WEIGHT_CLASS_UNKNOWN";
    case ChickenFightWeightClassPayload.CHICKEN_FIGHT_ABSOLUTE:
      return "CHICKEN_FIGHT_ABSOLUTE";
    case ChickenFightWeightClassPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
